export default function EarningDetails() {}
